import { render, staticRenderFns } from "./RadioWithValidation.vue?vue&type=template&id=622d2508&"
import script from "./RadioWithValidation.vue?vue&type=script&lang=js&"
export * from "./RadioWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports